import React from 'react';
import style from '../components/featuredInPress.module.css';
import PressLogos from '../../static/images/pressLogosGroup.svg'

const FeaturedInPress = () => {
 return (
    <section className={style.featuredSection}>
        <h3>Featured In</h3>
          <div>
            <img src={PressLogos}></img>
          </div>
    </section>
 )
};

export default FeaturedInPress;